// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monomer-collections-view {
  padding: 16px;
  overflow-y: auto;
  height: 100%;
}

.monomer-collections-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-content: flex-start;
}

.monomer-collection-card {
  width: 20%;
  min-width: 240px;
  height: 300px;
  border: 1px solid var(--grey-2);
  border-radius: 8px;
  background: var(--white);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.monomer-collection-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}

.monomer-collection-card-selected {
  border-color: #ff8c00;
  box-shadow: 0 0 0 1px #ff8c00;
}

.monomer-collection-card-selected:hover {
  box-shadow: 0 0 0 1px #ff8c00, 0 2px 12px rgba(0, 0, 0, 0.12);
}

.monomer-collection-card-header {
  padding: 12px 14px 8px 14px;
  border-bottom: 1px solid var(--grey-2);
  flex-shrink: 0;
}

.monomer-collection-card-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--grey-6);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.monomer-collection-card-description {
  font-size: 11px;
  color: var(--grey-4);
  margin: 4px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.monomer-collection-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin: 4px 0 0 0;
}

.monomer-collection-card-tag {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 3px;
  background: #e8f0fe;
  border: 1px solid var(--blue-2, #aecbfa);
  font-size: 10px;
  color: var(--blue-3, #4285f4);
}

.monomer-collection-card-meta {
  font-size: 10px;
  color: var(--grey-3);
  margin: 4px 0 0 0;
}

.monomer-collections-search {
  margin-bottom: 12px;
}

.monomer-collections-search input {
  width: 100%;
  max-width: 400px;
}

.monomer-collection-card-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px 14px;
  min-height: 0;
}

.monomer-collection-card-actions {
  padding: 0px 14px;
  border-top: 1px solid var(--grey-2);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-shrink: 0;
}

.monomer-collection-card-actions .ui-btn {
  font-size: 11px;
  padding: 2px 10px;
  margin: 0;
}

.monomer-collection-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.monomer-collection-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--grey-1);
  border: 1px solid var(--grey-2);
  font-size: 11px;
  color: var(--grey-5);
  cursor: pointer;
  transition: background 0.15s ease;
}

.monomer-collection-tag:hover {
  background: var(--blue-1, #e8f0fe);
  border-color: var(--blue-2, #aecbfa);
}

.monomer-collection-add-card {
  width: 20%;
  min-width: 240px;
  height: 300px;
  border: 2px dashed var(--grey-3);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.monomer-collection-add-card:hover {
  border-color: var(--blue-2, #aecbfa);
  background: var(--blue-1, #e8f0fe);
}

.monomer-collection-add-card-content {
  text-align: center;
  color: var(--grey-4);
}

.monomer-collection-add-card-content .grok-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.monomer-collection-add-card-content span {
  display: block;
  font-size: 13px;
}

.monomer-collections-load-more {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 16px 0;
}

.monomer-collections-load-more .ui-btn {
  min-width: 200px;
}

.monomer-collection-empty-state {
  width: 100%;
  text-align: center;
  padding: 60px 20px;
  color: var(--grey-4);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./css/monomer-collections.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":[".monomer-collections-view {\n  padding: 16px;\n  overflow-y: auto;\n  height: 100%;\n}\n\n.monomer-collections-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-content: flex-start;\n}\n\n.monomer-collection-card {\n  width: 20%;\n  min-width: 240px;\n  height: 300px;\n  border: 1px solid var(--grey-2);\n  border-radius: 8px;\n  background: var(--white);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: box-shadow 0.2s ease;\n}\n\n.monomer-collection-card:hover {\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);\n}\n\n.monomer-collection-card-selected {\n  border-color: #ff8c00;\n  box-shadow: 0 0 0 1px #ff8c00;\n}\n\n.monomer-collection-card-selected:hover {\n  box-shadow: 0 0 0 1px #ff8c00, 0 2px 12px rgba(0, 0, 0, 0.12);\n}\n\n.monomer-collection-card-header {\n  padding: 12px 14px 8px 14px;\n  border-bottom: 1px solid var(--grey-2);\n  flex-shrink: 0;\n}\n\n.monomer-collection-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--grey-6);\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.monomer-collection-card-description {\n  font-size: 11px;\n  color: var(--grey-4);\n  margin: 4px 0 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.monomer-collection-card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  margin: 4px 0 0 0;\n}\n\n.monomer-collection-card-tag {\n  display: inline-block;\n  padding: 1px 6px;\n  border-radius: 3px;\n  background: #e8f0fe;\n  border: 1px solid var(--blue-2, #aecbfa);\n  font-size: 10px;\n  color: var(--blue-3, #4285f4);\n}\n\n.monomer-collection-card-meta {\n  font-size: 10px;\n  color: var(--grey-3);\n  margin: 4px 0 0 0;\n}\n\n.monomer-collections-search {\n  margin-bottom: 12px;\n}\n\n.monomer-collections-search input {\n  width: 100%;\n  max-width: 400px;\n}\n\n.monomer-collection-card-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 14px;\n  min-height: 0;\n}\n\n.monomer-collection-card-actions {\n  padding: 0px 14px;\n  border-top: 1px solid var(--grey-2);\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.monomer-collection-card-actions .ui-btn {\n  font-size: 11px;\n  padding: 2px 10px;\n  margin: 0;\n}\n\n.monomer-collection-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.monomer-collection-tag {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: var(--grey-1);\n  border: 1px solid var(--grey-2);\n  font-size: 11px;\n  color: var(--grey-5);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.monomer-collection-tag:hover {\n  background: var(--blue-1, #e8f0fe);\n  border-color: var(--blue-2, #aecbfa);\n}\n\n.monomer-collection-add-card {\n  width: 20%;\n  min-width: 240px;\n  height: 300px;\n  border: 2px dashed var(--grey-3);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.monomer-collection-add-card:hover {\n  border-color: var(--blue-2, #aecbfa);\n  background: var(--blue-1, #e8f0fe);\n}\n\n.monomer-collection-add-card-content {\n  text-align: center;\n  color: var(--grey-4);\n}\n\n.monomer-collection-add-card-content .grok-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.monomer-collection-add-card-content span {\n  display: block;\n  font-size: 13px;\n}\n\n.monomer-collections-load-more {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 16px 0;\n}\n\n.monomer-collections-load-more .ui-btn {\n  min-width: 200px;\n}\n\n.monomer-collection-empty-state {\n  width: 100%;\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--grey-4);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
